import React, { useState } from "react";
import { NavLink as RouterNavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronRight, ChevronLeft } from "lucide-react";
import { sidebarLink } from "../../types/sidebarLink";
import i18next from "i18next";


type Props = {
  link: sidebarLink;
};

export default function NavLink({ link }: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const hasChildren = link.children && link.children.length > 0;

  return (
    <div>
      {/* رابط رئيسي */}
      {link.href ? (
        <RouterNavLink
          to={link.href}
          className={({ isActive }) =>
            `flex items-center justify-between p-2 rounded-md transition duration-300  font-bold cursor-pointer ${
              isActive
                ? "text-YellowSecondary"
                : "text-secondary hover:text-YellowSecondary"
            }`
          }
          onClick={() => hasChildren && setOpen(!open)}
        >
          <div className="flex items-center gap-2">
            <link.icon size={20} />
            <span className=" capitalize">{t(link.title)}</span>
          </div>

          {hasChildren && (
            <span>
              {open ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
            </span>
          )}
        </RouterNavLink>
      ) : (
        <div
          className="flex items-center justify-between p-2 rounded-md cursor-pointer text-secondary hover:text-YellowSecondary"
          onClick={() => hasChildren && setOpen(!open)}
        >
          <div className="flex items-center gap-2 font-bold">
            <link.icon size={20} />
            <span className=" capitalize">{t(link.title)}</span>
          </div>
          {hasChildren && (
            <span>
              {open ? <ChevronDown size={18} /> : i18next.language==="ar"? <ChevronLeft size={18}/> :<ChevronRight size={18} />}
            </span>
          )}
        </div>
      )}

      {/* روابط فرعية */}
      {hasChildren && open && (
        <div className="pl-6 mt-1">
          {link.children!.map((child) => (
            <RouterNavLink
              key={child.title}
              to={child.href!}
              className={({ isActive }) =>
                `flex items-center gap-2 p-2 rounded-md mb-2 text-sm font-bold transition duration-300 ${
                  isActive
                    ? "text-YellowSecondary"
                    : "text-secondary hover:text-YellowSecondary"
                }`
              }
            >
              <child.icon size={16} />
              <span className=" capitalize">{t(child.title)}</span>
            </RouterNavLink>
          ))}
        </div>
      )}
    </div>
  );
}
